import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-104" data-mp="3geze367ujv27">
      <div className="mx-auto max-w-5xl text-center" data-id="element-105" data-mp="3ggu1cr6lbz9g">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-106" data-mp="32oe281gt8ldt">
          <span className="text-brand" aria-hidden="true" data-id="element-107" data-mp="36p6bgupomqa3">
            ✦{' '}
          </span>
          MATHE BEREIT™
        </p>
        <p className="mt-1 text-xs text-ink/50" data-id="element-108" data-mp="3ug3bpa847z5i">Das komplette Mathematik-Curriculum</p>
        <nav aria-label="Footer" data-id="element-109" data-mp="38zaivynj750">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-110" data-mp="37xx4ku5y8k4">
            {footerLinks.map(link => <li key={link} data-id="element-111" data-mp="3qcdtd2i1adsx">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-112" data-mp="3qblxdqkiye24">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-113" data-mp="2ew6z8jgkxg5f">
          © 2026 MATHE BEREIT™. Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>;
}